import { Fix } from '@/types/database/fix';

export const statusColors: Record<Fix['status'], string> = {
  未處理: '#a85b5b',
  處理中: '#a85b5b',
  已安排: '#a85b5b',
  已處理: '#75add0',
};
